import React from 'react';
import PropTypes from 'prop-types';
import './Curve.css';

const Curve = ({
  hasUpper,
  hasLower,
  upperBackground,
  upperMain,
  lowerBackground,
  lowerMain,
  upperCurveDirection,
  lowerCurveDirection
}) => {
  return (
    <div className="curve-container">
      {hasUpper && (
        <div
          className="curve-upper-container"
          style={{ background: upperBackground }}
        >
          <div
            className="curve-upper"
            style={{
              background: upperMain,
              borderRadius:
                upperCurveDirection === 'right'
                  ? '0 0 100px 0'
                  : '0 0 0 100px'
            }}
          />
        </div>
      )}

      {hasLower && (
        <div
          className="curve-lower-container"
          style={{ background: lowerBackground }}
        >
          <div
            className="curve-lower"
            style={{
              background: lowerMain,
              borderRadius:
                lowerCurveDirection === 'right'
                  ? '100px 0 0 0'
                  : '0 100px 0 0'
            }}
          />
        </div>
      )}
    </div>
  );
};

Curve.propTypes = {
  upperBackground: PropTypes.string,
  upperMain: PropTypes.string,
  lowerBackground: PropTypes.string,
  lowerMain: PropTypes.string,
  hasUpper: PropTypes.bool,
  hasLower: PropTypes.bool,
  upperCurveDirection: PropTypes.oneOf([ 'right', 'left' ]),
  lowerCurveDirection: PropTypes.oneOf([ 'right', 'left' ])
};

Curve.defaultProps = {
  hasUpper: true,
  hasLower: true,
  upperCurveDirection: 'right',
  lowerCurveDirection: 'right'
};

export default Curve;